import { render, staticRenderFns } from "./KCheckbox.vue?vue&type=template&id=fadec544&"
import script from "./KCheckbox.vue?vue&type=script&lang=ts&"
export * from "./KCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports